import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation MFATOTPValidate($passcode: String!) {
    mfaTotpValidate(passcode: $passcode) {
      success
      accessToken
    }
  }
`

export const mfaTotpValidateKey = getQueryNames(mutation)[0]

export default mutation
